export default "__VITE_ASSET__DgrDc6mB__"